import {
  Text,
} from '@chakra-ui/react';
import { selectedDatabaseIdState, availableDatabasesState } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import { selectedRegionRoadTypeState } from '../state';

function GroupedRegionMessage({
  rcaIds = [], roadTypes = [], messagePrefix = 'Combined results for', messageSuffix = '',
}) {
  const rcaId = useRecoilValue(selectedDatabaseIdState);
  const allDatabases = useRecoilValue(availableDatabasesState);
  const selectedRegionRoadType = useRecoilValue(selectedRegionRoadTypeState);

  const rcaNames = allDatabases.filter((db) => rcaIds.includes(db.id))
    .map((db) => db.name.replace(' Region', '')) || null;

  const rcaNamesMessage = rcaNames.length > 1
    ? `${rcaNames.slice(0, -1).join(', ')} and ${rcaNames.slice(-1)}`
    : rcaNames[0];

  if (!rcaNames || !rcaIds.includes(rcaId) || (roadTypes.length > 0 && !roadTypes.includes(selectedRegionRoadType))) {
    return null;
  }

  return (
    <Text
      fontSize="11px"
      color="gray.500"
      textAlign="center"
      mt={3}
      wordBreak="break-word"
      overflowWrap="break-word"
      whiteSpace="normal"
      fontStyle="italic"
      className="grouped-region-message"
    >
      {messagePrefix}
      {' '}
      {rcaNamesMessage}
      {messageSuffix && (
      <>
        <br />
        {messageSuffix}
      </>
      )}
    </Text>
  );
}

export default GroupedRegionMessage;
